export default __webpack_public_path__ + "media/images/about_us/dinner-room-ae990209e8df257a932126199b046b3b.png";